angular.module('impactx.dialog').service('ExtendedCatalogTooltipService', [
    '$mdPanel',
    'themeFactory',
    '$timeout',
    'dataGen',
    ExtendedCatalogTooltipService
]);

function ExtendedCatalogTooltipService($mdPanel, themeFactory, $timeout, dataGen) {

    var panelRef = null;
    var timer;
    var isOpen = false;
    var isMouseOverTooltip = false;

    function open(event, catalog, delay) {
        stopTimer();
        if (isOpen) {
            return;
        }

        if (!panelRef) {
            timer = $timeout(function () {
                var tempScope = {};
                dataGen.getData(tempScope, {id: catalog.id}, "/vcatalog/tooltip").then(function () {
                    var tooltipConfig = {
                        attachTo: angular.element(document.body),
                        controller: function () {
                            this.theme = themeFactory.getTheme();
                            this.data = tempScope.data;
                        },
                        controllerAs: '$ctrl',
                        position: $mdPanel.newPanelPosition().relativeTo(event.target)
                            .addPanelPosition(
                                $mdPanel.xPosition.CENTER,
                                $mdPanel.yPosition.BELOW
                            )
                            .addPanelPosition(
                                $mdPanel.xPosition.OFFSET_END,
                                $mdPanel.yPosition.CENTER),
                        event: event,
                        templateUrl: 'shared/panel/templates/extended-catalog-tooltip.tmpl.html',
                        panelClass: 'extended-catalog-tooltip-panel',
                        propagateContainerEvents: true,
                        pointerEvents: true,
                        onDomAdded: function (panelRef) {
                            var panel = panelRef[1].panelEl;
                            panel.on('mouseenter', function () {
                                isMouseOverTooltip = true;
                            });
                            panel.on('mouseleave', function (e) {
                                isMouseOverTooltip = false;
                                close();
                            });
                        },
                        clickOutsideToClose: true,
                    };

                    panelRef = $mdPanel.create(tooltipConfig);

                    if (!isOpen) {
                        isOpen = true;
                        panelRef.open();

                    }
                });
            }, delay);
        }
    };

    function close() {
        $timeout.cancel(timer);
        $timeout(function () {
            if (panelRef && isOpen && !isMouseOverTooltip) {
                panelRef.close().then(function () {
                    panelRef.destroy();
                    panelRef = null;
                    isOpen = false;
                });
            }
        }, 100);

    };

    function stopTimer() {
        if (timer) {
            $timeout.cancel(timer);
        }
    };

    return {
        open: open,
        close: close,
        stopTimer: stopTimer,
    };
}
